import React, { Context, ReactElement, Component, useState } from 'react';
import { records_type } from "./records";
// import { operation_type } from '../components/new-table-list/table-list';
// import { client_type } from '../pages/clients/clients';
// import { tunnel_type } from '../pages/tunnels/tunnels';

// export interface item {
//   id?: string;
//   name?: string;
//   subscription_id?: string;
//   tag_name?: string;
//   version?: string;
//   description?: string;
//   config_description?: string;
//   release_type?: string;
//   release_status?: boolean;
//   created_time?: number;
//   updated_time?: number;
//   status?: string;
//   app_group_name?: string;
//   app_group_id?: string;
//   quota?: any;
//   config_id?: any;
//   config_name?: any;
//   service_name?: string;
//   enable_white_list?: boolean;
//   port_services_name?: string;
//   portServiceName?: string;
//   public_bindable?: boolean;
//   enable_rate_list?: boolean;
//   service_infos?: any[];
//   replaceEnv?: boolean;
//   replaceArgs?: boolean;
// }

export interface table_list_type {
//   item_selected?: item | undefined;
//   dropdown_menus?: dropdown_menu_item[];

//   clients?: client_type[];
//   tunnels?: tunnel_type[];

//   set_tunnels: React.Dispatch<React.SetStateAction<any[]>>;

//   client?: string;
//   tunnel?: string;
//   type?: string;
    records?: records_type[];
}

const TableListContext: Context<[table_list_type, React.Dispatch<React.SetStateAction<table_list_type>>]> = React.createContext<
  [table_list_type, React.Dispatch<React.SetStateAction<table_list_type>>]
>([{} as table_list_type, (_value: any) => {}]);

const TableListProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (
  props: any
): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [table_list, set_table_list] = useState({} as table_list_type);
  return <TableListContext.Provider value={[table_list, set_table_list]}>{props.children}</TableListContext.Provider>;
};

export { TableListContext, TableListProvider };
